import { ALL_CATEGORY_NAME, BRAND_NAME_URL_SUFFIX } from "../../../constants";
import { Brand } from "../../../services/brandsService";

const getBrandUrlWithCategorySlug = (
  data: Brand,
  selectedCategorySlug: string
) => {
  const parentCategorySlug = data.category.key;

  const catSlug =
    selectedCategorySlug === ALL_CATEGORY_NAME
      ? ALL_CATEGORY_NAME
      : parentCategorySlug;
  const brandName = data.brand.key;

  const brandRegex = /{brand}/;

  let url = `${BRAND_NAME_URL_SUFFIX}/{brand}/`;

  if (catSlug === ALL_CATEGORY_NAME) {
    url = url.replace(brandRegex, () => {
      return brandName;
    });
  } else {
    url = `/${catSlug}${BRAND_NAME_URL_SUFFIX}/${brandName}/`;
  }

  return url;
};

export default getBrandUrlWithCategorySlug;
